import api from "./api";

export const fetchVirtualAccounts = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, searchBy, searchByExactMatch }] =
    queryKey;
  let url = `/virtual-accounts?page=${page}&limit=${limit}`;
  
  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  // if (currency) {
  //   url += `&currency=${currency}`;
  // }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchVirtualAccount = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/virtual-accounts/${id}`);
  return response.data;
}

export const fetchUserVirtualAccount = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/users/virtual-accounts/${id}`);
  return response.data;
}

export const fetchVirtualAccountMetrics = async () => {
  const response = await api.get(`/virtual-accounts/metrics`)
  return response.data;
}

export const exportVirtualAccount = async (data) => {
  const response = await api.post(`/export/virtualAccount`, data);
  return response.data;
}